import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import { Field, reduxForm } from 'redux-form';
import './main.less';

import ModalBox from '../../../shared/modal';
import SelectField from '../../../shared/form-elements/select/field';
import CheckboxField from '../../../shared/form-elements/checkbox';
import Input from '../../../shared/form-elements/input';
import { formatYearMonth } from '../../../shared/format';

const Form = props => {
	const submit = data => props.submitApproveDaily(data);
	return (
		<div className='approve-daily-form display-flex-column'>
			<div className="approve-daily-container">
				{
					props.dailyApprovesList.map((item, index) =>
						<div className="display-flex row" key={index}>
							<div className="cell width-300">
								<p>
									ID: {item.id}
								</p>
								<p>
									Offer: {item.offer}
								</p>
								<p>
									Country: {item.country}
								</p>
								<p>
									Sid: {item.sid}
								</p>
							</div>
							<div className="cell width-300 margin-0-10">
								{item.start_date} - {item.end_date}
							</div>
							<div className="cell width-200">
								<p>Approve: {item.approve_percent}</p>
								<p>Minimum leads count: {item.minimum_leads_count}</p>
								<p>Start leads count: {item.start_leads_count}</p>
								<p>Expected trash percent: {item.trash_percent}</p>
								<p>T80 (hours): {Math.floor(item.t80_hours)}</p>
							</div>
							<div className="cell width-200">{(!!item.is_lead_status_changed).toString()}</div>
							<div className="cell">
								<span
									className="delete"
									onClick={props.deleteApproveDaily.bind(null, item.id)}
								/>
								<span
									className="edit margin-0-10"
									onClick={props.setInitialFormData.bind(null, item.id)}
								/>
							</div>
						</div>
					)
				}
			</div>
			<form
				className='ui-form payouts-form__main clearfix'
				onSubmit={props.handleSubmit(submit)}
			>
				<div>
					<p  className="display-flex">
						<div className="ui-form__element width-300">

							<Field
								name="offer_id"
								placeholder={'Offers'}
								multi={false}
								searchable={true}
								options={props.dailyOffersLookup}
								component={SelectField}
								showLabel={false}
							/>
						</div>
						<div className="ui-form__element width-300 margin-0-10">
							<Field
								name="country_code"
								placeholder={props.intl('Countries')}
								multi={false}
								searchable={true}
								options={props.approveLocationsLookups.bind(null, true)}
								component={SelectField}
								showLabel={false}
							/>
						</div>
						<div className="ui-form__element width-200">
							<Field
								name="approve_percent"
								placeholder={props.intl('Target approve') + ', %'}
								type="number"
								normalize={
									(value, oldValue) => {
										if (!Number(value)) {
											return '';
										}
										return Number(value) >= 0 && Number(value) <= 100 ? Number(value) : oldValue;
									}
								}
								component={Input}
								showLabel={false}
							/>
						</div>
						<div className="ui-form__element width-200 margin-0-10">
							<Field
								name="sid"
								placeholder={props.intl('Sid')}
								component={Input}
								showLabel={false}
							/>
						</div>
						<div className="ui-form__element width-200 margin-0-10">
							<Field
								name="minimum_leads_count"
								type="number"
								placeholder={props.intl('Minimum leads')}
								component={Input}
								showLabel={false}
							/>
						</div>
						<div className="ui-form__element width-200 margin-0-10">
							<Field
								name="start_leads_count"
								type="number"
								placeholder={props.intl('Start leads')}
								component={Input}
								showLabel={false}
							/>
						</div>
						<div className="ui-form__element width-200 checkbox-label-shifted">
							<Field
								name="is_lead_status_changed"
								placeholder={props.intl('Can lead status be changed')}
								component={CheckboxField}
							/>
						</div>
					</p>
					<p className="display-flex margin-0-0-10-0">
						<div className="ui-form__element width-200">
							<Field
								name="start_date"
								placeholder={props.intl('Start date i.e. 2022-11-23')}
								normalize={formatYearMonth}
								component={Input}
								showLabel={false}
							/>
						</div>
						<div className="ui-form__element width-200 margin-0-10">
							<Field
								name="end_date"
								placeholder={props.intl('End date i.e. 2022-11-23')}
								normalize={formatYearMonth}
								component={Input}
								showLabel={false}
							/>
						</div>
						<div className="ui-form__element width-200 margin-0-10">
							<Field
								name="trash_percent"
								placeholder={props.intl('Expected trash') + ', %'}
								type="number"
								normalize={
									(value, oldValue) => {
										if (!Number(value)) {
											return '';
										}
										return Number(value) >= 0 && Number(value) <= 100 ? Number(value) : oldValue;
									}
								}
								component={Input}
								showLabel={false}
							/>
						</div>
						<div className="ui-form__element width-200 margin-0-10">
							<Field
								name="id"
								type="number"
								placeholder="ID"
								component={Input}
								showLabel={false}
								disabled={true}
							/>
						</div>
					</p>
				</div>
				<button
					className={cn({
						'ui-btn': true,
						'ui-btn-primary apply': true
					})}
					type='submit'
				>{props.intl('Apply')}</button>
				<button
					className='ui-btn ui-btn-cancel cancel'
					onClick={e => {
						e.preventDefault();
						props.toggleApproveDailyForm();
					}}
				>{props.intl('Cancel')}</button>
			</form>
		</div>
	);
};

Form.propTypes = {
	intl: PropTypes.func
};

const Main = props =>
	<ModalBox
		title={props.intl('Approve daily')}
		body={Form(props)}
		isOpen={props.isApproveDailyFormVisible}
		onClose={props.toggleApproveDailyForm}
		className='form-modal approve-daily-modal'
	/>;

Main.propTypes = {
	intl: PropTypes.func
};

const validate = values => {
	const errors = {};
	if (!!values.minimum_leads_count && !!values.start_leads_count) {
		errors['minimum_leads_count'] = `Can't have both minimum_leads_count and start_leads_count`;
		errors['start_leads_count'] = `Can't have both minimum_leads_count and start_leads_count`;
	}
	return errors;
};

export default formName => reduxForm({
	form: formName, validate, enableReinitialize: true
})(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/approve-daily-form/main.js